export default "__VITE_ASSET__e7640a9e__"